// src/services/auth/authPassword.ts
import { supabase } from '@/lib/supabase';

type ChangePasswordDeps = {
    user: any | null;
};

type ResetPasswordDeps = {
    setRecoveryToken: (t: string | null) => void;
};

export const changePasswordService = async (
    currentPassword: string,
    newPassword: string,
    { user }: ChangePasswordDeps,
): Promise<{ success: boolean; error: string }> => {
    try {
        const { error: signInError } = await supabase.auth.signInWithPassword({
            email: user?.email,
            password: currentPassword,
        });

        if (signInError) {
            console.error(
                'Errore durante la verifica della password attuale:',
                signInError,
            );
            throw new Error('Password attuale non corretta');
        }

        const { error: updateError } = await supabase.auth.updateUser({
            password: newPassword,
        });

        if (updateError) {
            console.error(
                "Errore durante l'aggiornamento della password:",
                updateError,
            );
            throw new Error("Errore durante l'aggiornamento della password");
        }

        return { success: true, error: '' };
    } catch (error: any) {
        console.error('Errore durante il cambio password:', error);
        return {
            success: false,
            error: error?.message || 'Errore durante il cambio password',
        };
    }
};

export const forgotPasswordService = async (
    email: string,
): Promise<{ success: boolean; error: string }> => {
    try {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/auth/callback?redirect_type=recovery`,
        });

        if (error) {
            console.error(
                "Errore durante l'invio dell'email di reset:",
                error,
            );
            throw new Error("Errore durante l'invio dell'email di reset");
        }

        console.log('Email di reset inviata');
        return { success: true, error: '' };
    } catch (error: any) {
        console.error('Errore durante il reset password:', error);
        return {
            success: false,
            error:
                error?.message ||
                "Errore durante l'invio dell'email di reset",
        };
    }
};

export const resetPasswordService = async (
    newPassword: string,
    { setRecoveryToken }: ResetPasswordDeps,
): Promise<{ success: boolean; error: string }> => {
    try {
        const { error } = await supabase.auth.updateUser({
            password: newPassword,
        });

        if (error) {
            console.error('Errore durante il reset della password:', error);
            throw new Error('Errore durante il reset della password');
        }

        setRecoveryToken(null);
        return { success: true, error: '' };
    } catch (error: any) {
        console.error('Errore durante il reset password:', error);
        return {
            success: false,
            error:
                error?.message || 'Errore durante il reset della password',
        };
    }
};